import React from 'react';

import { tabs } from '../../constants';

import styles from './styles.module.scss';

export const ProgressList: React.FC = () => (
  <div className={styles.progressBarList}>
    {
      tabs.map(({ icon: Icon, title }) => (
        <div
          className={styles.item}
          key={title}
        >
          <Icon />
          <span className={styles.title}>{title}</span>
        </div>
      ))
    }
  </div>
);
